(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        (function() {
            "use strict";
            if (window.__erkShowroomHeroInitialized__) {
                return;
            }
            window.__erkShowroomHeroInitialized__ = true;
            const initializedClass = "erk-showroom-hero--initialized";
            function initSection(section) {
                if (section.classList.contains(initializedClass)) return;
                section.classList.add(initializedClass);
                const revealElements = section.querySelectorAll("[reveal-on-scroll]");
                if (revealElements.length === 0) return;
                if (!("IntersectionObserver" in window)) {
                    revealElements.forEach((function(el) {
                        el.classList.add("is-revealed");
                    }));
                    return;
                }
                const observer = new IntersectionObserver((function(entries) {
                    entries.forEach((function(entry) {
                        if (entry.isIntersecting) {
                            entry.target.classList.add("is-revealed");
                            observer.unobserve(entry.target);
                        }
                    }));
                }), {
                    threshold: .15
                });
                revealElements.forEach((function(el) {
                    observer.observe(el);
                }));
            }
            function initAll() {
                const sections = document.querySelectorAll(".erk-showroom-hero:not(." + initializedClass + ")");
                sections.forEach(initSection);
            }
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", initAll);
            } else {
                initAll();
            }
            document.addEventListener("shopify:section:load", (function(event) {
                const section = event.target.querySelector(".erk-showroom-hero");
                if (section) {
                    section.classList.remove(initializedClass);
                    initSection(section);
                }
            }));
        })();
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();